module.exports = __webpack_public_path__ + "img/pigai-mobile-order.04096366.png";